import { useDispatch, useSelector } from "react-redux";
import { operationalAiInsightsSelector } from "../../Reducers/operationalAiInsightsReducer";
import { reviewAiInsightsSelector } from "../../Reducers/reviewAiInsightsReducer";
import ComponentHeader from "../CommonComponents/componentHeader";
import { getReviewAiInsights } from "../../Actions/reviewAiInsightsAction";
import { getOperationalAiInsights } from "../../Actions/operationalAiInsightsAction";
import { useEffect, useState } from "react";
import "../../Stylesheets/insights.css";
import OperationalInsightsList from "./OperationalInsightsList";
import SlidingTab from "./SlidingTab";
import ReviewInsightsList from "./ReviewInsightsList";
export const AI_INSIGHTS = "AI_INSIGHTS";



const AiInsightWrapper = () => {
  const dispatch = useDispatch();
  const reviewAiInsights = useSelector(reviewAiInsightsSelector);
  const operationalAiInsights = useSelector(operationalAiInsightsSelector);
  const [activeTab, setActiveTab] = useState('review');

  useEffect(() => {
    dispatch(getOperationalAiInsights());
  }, [dispatch]);

  const onReviewOptionChange = (timeframe) => {
    dispatch(getReviewAiInsights(timeframe));
  }

  return (
    <>
      <ComponentHeader title={"AI Insights"} />
      <SlidingTab 
        menuArr={["Review Insights", "Operational Insights"]} 
        selectedInd={activeTab === 'review' ? 0 : 1} 
        setIndex={(index) => setActiveTab(index === 0 ? 'review' : 'operational')}
      />
      <div className="tab-content">
        {activeTab === 'review' && (
          <ReviewInsightsList insights={reviewAiInsights} onOptionChange={onReviewOptionChange} />
        )}
        {activeTab === 'operational' && (
          <OperationalInsightsList insights={operationalAiInsights} />
        )}
      </div>
    </>
  );
};
export default AiInsightWrapper;
